module.exports = __webpack_public_path__ + "img/icon-logout.f9b4051f.svg";